export default __webpack_public_path__ + "static/voting-app-2632f08e5503448504f968e52dfe92a1.png";